var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFntUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2896",
    "data-name": "Group 2896",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1263",
    "data-name": "Rectangle 1263",
    width: 24,
    height: 24,
    transform: "translate(0)",
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_242",
    "data-name": "Group 242",
    transform: "translate(2.691 3.058)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1590",
    "data-name": "Path 1590",
    d: "M.369-12.36V2.722m-6.406-8.77L.369-13.1,6.775-6.049",
    transform: "translate(8.94 15.905)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 1.298
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1591",
    "data-name": "Path 1591",
    d: "M-2.382,6.67V0H-21V6.67",
    transform: "translate(21 0)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.276
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFntUpload);
export default __webpack_public_path__ + "static/media/fnt_upload.17af9eed75c52e82c1887033c4a2df14.svg";
export { ForwardRef as ReactComponent };